import React from 'react'
import ProbelyMappingForm from './ProbelyMappingForm';
import ProbelyCredentialsForm from './ProbelyCredentialsForm';
import GenericPullConfigListing from '../GenericPullConfigListing';

export default function ProbelyConfigListing(props) {

    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={ProbelyMappingForm}
            CredentialsForm={ProbelyCredentialsForm}
            componentName="Application"
            componentKey="applicationName"
        />
    )
}